/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import FormInput from "../../../components/forms/form-Input";
import { accountDefault } from "../constants";

export default function Accounts({
  onNextStep,
  onPrevStep,
  accounts,
  addData,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: accounts
      ? { ...accountDefault, accounts: [...accounts] }
      : { ...accountDefault },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    title: { required: "Please add title" },
    accountNo: { required: "please add account no" },
  };
  const { fields: accountFields, remove: accountRemove } = useFieldArray({
    control: generalFieldProps.control,
    name: "accounts",
  });
  useEffect(() => {
    if (addData) addData([...accountFields]);
  }, [watch("accounts")]);
  const submitInfo = (data) => {
    const _data = { ...data };
    const _accounts = [...accountFields];
    const newItem = {
      title: _data.title,
      accountNo: _data.accountNo,
      branchCode: _data.branchCode,
    };
    if (currentEditing !== null) {
      setCurrentEditing(null);
      _accounts[currentEditing] = newItem;
    } else {
      _accounts.push(newItem);
    }
    reset({ ...accountDefault, accounts: _accounts });
  };
  const cancelEditing = () => {
    setCurrentEditing(null);
    const _accounts = [...accountFields];
    reset({ ...accountDefault, accounts: _accounts });
  };
  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Account"
          cursor="pointer"
          onClick={() => {
            const _accounts = accountFields;
            reset({ ...getValues(), ...dataItem, accounts: _accounts });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Account"
          cursor="pointer"
          onClick={() => {
            accountRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Accounts</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button
              type="button"
              onClick={() => onPrevStep([...accountFields])}
            >
              Back
            </Button>
            <Button
              type="button"
              onClick={() => onNextStep([...accountFields])}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Title"
        rules={formValidationRules.title}
        name="title"
      />
      <FormInput
        {...generalFieldProps}
        label="Account Number"
        isRequired
        rules={formValidationRules.accountNo}
        name="accountNo"
      />
      <FormInput {...generalFieldProps} label="Branch Code" name="branchCode" />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button type="button" onClick={cancelEditing}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button
          type="submit"
          isDisabled={!watch("title") && !watch("accountNo")}
        >
          {currentEditing !== null ? "Update" : "Add"}
        </Button>
      </div>
      <Grid data={accountFields}>
        <GridColumn field="title" title="Title" />
        <GridColumn field="accountNo" title="Account No" />
        <GridColumn field="branchCode" title="Branch Code" />
        <GridColumn title="Edit" width="80" cell={editCell} />
        <GridColumn title="Delete" width="80" cell={deleteCell} />
      </Grid>
    </form>
  );
}
